import React from 'react'
import styles from './UIGamePlayerInfoSection.module.scss'

interface UIGamePlayerInfoSectionProps {
    children: React.ReactNode
}

export const UIGamePlayerInfoSection = ({
    children,
}: UIGamePlayerInfoSectionProps) => (
    <div className={styles.container}>
        {children}
    </div>
)
